export function extractDate(date) {
  var date = new Date(date);
  var str = date.getDay() + "-" + date.getMonth() + "-" + date.getFullYear();
  return str;
}
